import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

// Enable future flags for React Router v7
export const routerConfig = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

export { NavigationContext }; 